<template>
  <v-dialog max-width="600px" v-model="dialogModel">
    <v-card>
      <v-card-title>
        <span v-if="isEdit">{{ $t('message.editFaq') }}</span>
        <span v-else>
          <Address></Address>
          {{ $t('message.addFaq') }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-form ref="faqForm" v-model="faqForm.valid">
          <v-container grid-list-md pt-0>
            <v-layout row wrap>
              <v-flex md12 xs12>
                <v-text-field
                  :rules="faqForm.questionRules"
                  :label="$t('message.question')"
                  prepend-icon="help"
                  required
                  v-model="faqForm.question"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex md12 xs12>
                <v-text-field
                  :rules="faqForm.answerRules"
                  :label="$t('message.answer')"
                  prepend-icon="zmdi-comment-more"
                  required
                  v-model="faqForm.answer"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outline @click="onClose" color="error" small>{{ $t('message.close') }}</v-btn>
        <v-btn outline @click="onSave" color="primary" small>{{ $t('message.save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "manageFaq",
  props: {
    faq: {
      type: Object,
      required: false,
      default: function() {
        return {
          id: 0,
          answer: "",
          question: ""
        };
      }
    },
    dialog: {
      required: false,
      default: false
    },
    isEdit: {
      required: false,
      default: false
    }
  },
  data() {
    return {
      faqForm: {
        question: "",
        answer: "",
        valid: false,
        questionRules: [ value => value.length >= 5 || 'Debe tener 5 caracteres como minimo'],
        answerRules: [v => !!v || "Please, enter the question"]
      },
      dialogModel: this.dialog,
    };
  },
  methods: {
    onClose() {
      this.$emit("update:dialog", false);
      this.faqForm.question = "";
      this.faqForm.answer = "";
      this.$refs.faqForm.reset();
    },
    onSave() {
      if (this.$refs.faqForm.validate()) {
        this.$emit("on-save", {
          question: this.faqForm.question,
          answer: this.faqForm.answer
        });
        this.$emit("update:dialog", false);
        this.faqForm.question = "";
        this.faqForm.answer = "";
        this.$refs.faqForm.reset();
      }
    },
    setValue(faq) {
      this.faqForm.question = faq.question;
      this.faqForm.answer = faq.answer;
    }
  },
  watch: {
    dialog(value) {
      this.dialogModel = value;
    },
    dialogModel(value) {
      this.$emit("update:dialog", value);
    }
  }
};
</script>

<style>
</style>
